import { EnumTipoAutenticacaoEnvioPortalUnico } from "@catalogo/features/operacional/enums/enum-entities";

export class UsuarioCertificadoStateModel {
  existeUsuario: boolean;
  existePadrao: boolean;
  nomeCertificado?: string;
  dataVencimento?: Date;
  cpf?: string;
  modalSenha: string;
  modalSenhaConfirmado: boolean;
  modalRemover: string;
  tipoAutenticacaoSelecionado?: EnumTipoAutenticacaoEnvioPortalUnico;
}
